export const constructStrRep = (obj) => {
  if (obj.str_representation) return obj.str_representation;
  return "Indextabell";
};

export const overviewUrl = () => ``;

export const detailUrl = ({ id }) =>
  `/configcenter/indexations/tables/detail/${id}`;
